export default __webpack_public_path__ + "static/media/metersInActiveIcon.8d4a9275.svg";